// src/api/companies.js
import axios from 'axios';
import CONFIG from '../config';

class CompaniesAPI {
  constructor() {
    // Use API_V1_BASE_URL for companies endpoint
    this.api = axios.create({
      baseURL: CONFIG.API.API_V1_BASE_URL,
    });

    this.api.interceptors.request.use(
      (config) => {
        const token = CONFIG.getToken();
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );
  }

  // Get company suggestions
  async getSuggestions(search, limit = 10) {
    try {
      const response = await this.api.get(
        CONFIG.getEndpoint(CONFIG.API.COMPANIES.SUGGESTIONS, true),
        {
          params: { search, limit }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error getting company suggestions:', error);
      throw error;
    }
  }

  // Check if company exists
  async checkCompanyExists(companyName) {
    try {
      const suggestions = await this.getSuggestions(companyName, 1);
      if (suggestions && Array.isArray(suggestions)) {
        return suggestions.length > 0;
      }
      return false;
    } catch (error) {
      console.error('Error checking company:', error);
      return false;
    }
  }
}

export default new CompaniesAPI();